import { render, staticRenderFns } from "./onIndd.vue?vue&type=template&id=3553bd51"
import script from "./onIndd.vue?vue&type=script&lang=js"
export * from "./onIndd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports